import { render, staticRenderFns } from "./DealerTeamMember.vue?vue&type=template&id=9702a010&scoped=true"
import script from "./DealerTeamMember.vue?vue&type=script&lang=js"
export * from "./DealerTeamMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9702a010",
  null
  
)

export default component.exports